<script>
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
</script>

<style>
	.modal {
	    position: fixed;
	    top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        background: rgba(36,41,39,0.95);
	}
	.in {
	    display: flex;
        align-items: center;
        justify-content: center;
	    height: 100%;
	    width: 100%;
	}

	button {
		display: block;
	}
</style>


<div class='modal' on:click={() => dispatch('close')}>
	<div class="in">
	    <slot></slot>
    </div>
</div>
